export default (ctx, inject) => {
	inject('routerHelper', {
		getPathByRouteName (name, params) {
			let matchRoute = null
			for(let route of ctx.app.router.options.routes) {
				if(route.name === name) {
					matchRoute = route
					break
				}
			}

			if(matchRoute !== null) {
				let path = matchRoute.path
				let param = ''
				for(let key in params) {
					/* no-prototype-builtins */
					// if (!params.hasOwnProperty(key)) continue;

					if(name === 'property-detail' && key === 'title') {
						// param = params[key].split('/').join('∕').split(' ').join('-')
						param = (params[key] || '').split('/').join('-').split(' ').join('-')
					} else {
						param = params[key]
					}
					path = path.replace(':' + key, param)
				}
				return path
			}

			return '/'
		},

		getPathByRouteNameWithQuery (name, query) {
			let matchRoute = null
			for(let route of ctx.app.router.options.routes) {
				if(route.name === name) {
					matchRoute = route
					break
				}
			}

			if(matchRoute !== null) {
				let path = matchRoute.path + '?'
				for(let key in query) {
					path += key + '=' + query[key] + '&'
				}
				return path.substr(0, path.length-1)
			}

			return '/'
		}
	})
}
